import moment from "moment";
import React from "react";
import { Col, Row } from "react-bootstrap";
import CartItem from "../cartItem/cartItem";
import ShowMoreShowLessText from "../ShowMoreShowLess/ShowMoreShowLessText";

import classes from "./OrderItem.module.css";

const OrderItem = ({ data }) => {
  return (
    <div className={classes?.container}>
      <RowItem label={"Order Id"} value={data?._id} />
      <RowItem
        label={"User Name"}
        value={`${data?.firstName} ${data?.lastName}`}
      />
      <RowItem label={"Email"} value={data?.email} />
      <RowItem label={"telephone"} value={data?.telephone} />
      <RowItem
        label={"County | State"}
        value={`${data?.country} | ${data?.state}`}
      />
      <RowItem
        label={"Town | Post Code"}
        value={`${data?.town} | ${data?.postCode}`}
      />
      <RowItem
        label={"Address"}
        value={`${data?.addressLine1} | ${data?.addressLine2}`}
      />
      <RowItem
        label={"Order Price"}
        value={`$${parseFloat(data?.totalPrice).toFixed(2)}`}
      />
      <RowItem label={"Order Status"} value={data?.status} />
      <RowItem
        label={"Order Placed At"}
        value={moment(data?.createdAt).format("lll")}
      />

      <Row className={classes?.cartItems}>
        {data?.items?.map((e, i) => {
          return (
            <CartItem
              key={i}
              data={{ quantity: e.quantity, ...e?.cardId, ...e?.collectionId }}
              cardPrice={e?.price}
              removeActions
            />
          );
        })}
      </Row>
    </div>
  );
};

export default OrderItem;

const RowItem = ({ label, value }) => {
  return (
    <div className={classes?.reviewItem}>
      <p>
        <b className="t-t-c">{label}:</b>
        <ShowMoreShowLessText text={value} visibility={200} />
      </p>
    </div>
  );
};
